﻿<template>
    <Dialog v-model:visible="isVisible" modal :header="$t('accMgmt.title')" class="w-30rem" @hide="onHide">
        <div class="flex flex-column">
            <div class="flex align-items-center gap-3 mb-3">
                <label class="font-semibold w-6rem">{{$t('accMgmt.account')}}</label>
                <span>{{userInfo.account}}</span>
            </div>
            <div class="flex align-items-center gap-3 mb-5">
                <label class="font-semibold w-6rem">{{$t('accMgmt.name')}}</label>
                <IconField>
                    <InputIcon>
                        <i class="pi pi-user" />
                    </InputIcon>
                    <InputText v-model="name" :invalid="!name" class="" :placeholder="$t('accMgmt.name')" autofocus fluid></InputText>
                </IconField>
                <div class="pl-1">
                    <Button :icon="$t('accMgmt.changeNameIcon')" @click="onChangeName" :disabled="name==userInfo.name||!oSecret||oSecret.length<5" v-tooltip.right="$t('accMgmt.changeName')"></Button>
                </div>
            </div>
            <div class="flex align-items-center gap-3 mb-5">
                <label class="font-semibold w-6rem">{{$t('accMgmt.oSecret')}}</label>
                <IconField>
                    <InputIcon>
                        <i class="pi pi-key" />
                    </InputIcon>
                    <InputText :invalid="!oSecret" v-model="oSecret" :feedback="false" class="" :placeholder="$t('accMgmt.oSecretPlaceholder')" type="password" autocomplete="new-password" spellcheck="false" fluid></InputText>
                </IconField>
            </div>
            <div class="flex align-items-center gap-3 mb-5">
                <label class="font-semibold w-6rem">{{$t('accMgmt.nSecret')}}</label>
                <IconField>
                    <InputIcon>
                        <i class="pi pi-key" />
                    </InputIcon>
                    <InputText :invalid="!nSecret" v-model="nSecret" :feedback="false" class="" :placeholder="$t('accMgmt.nSecretPlaceholder')" type="password" autocomplete="new-password" spellcheck="false" fluid></InputText>
                </IconField>
                <div class="pl-1">
                    <Button :icon="$t('accMgmt.changeSecretIcon')" @click="onChangeSecret" :disabled="!oSecret||oSecret.length<5||!nSecret||nSecret.length<5" v-tooltip.right="$t('accMgmt.changeSecret')"></Button>
                </div>
            </div>
        </div>
    </Dialog>
</template>

<style scoped>
</style>

<script lang="ts">
    //normal <script> executed in module scope (only once)
    //只會執行一次(第1次) 除非按下F5

    export default {
        name: module$.accMgmt,
        inheritAttrs: false
    }
</script>

<script setup lang="ts">
    import { ref, watchEffect, watch } from 'vue'
    import { utilfcty$ } from '../utils/utility'
    import { useI18n } from 'vue-i18n';
    import { module$, url$ } from '../enums'
    import { storeToRefs } from 'pinia'

    const props = defineProps({
        visible: { type: Boolean, required: true, default: false }
    })

    const emit = defineEmits(['update:visible']);

    //***************工具物件***************
    const util$ = utilfcty$.vueUse();
    const appStore = util$.pinia$.security;
    //locales/{locales}/accMgmt.json
    const { t } = useI18n(); // 取得翻譯函式 t
    const { userInfo } = storeToRefs(appStore);
    const name = ref(userInfo.value.name);
    const oSecret = ref('');
    const nSecret = ref('');
    const loading = ref(false);


    //***************屬性/計算**************

    let isVisible = ref(props.visible);

    //***************元件函式**************
    const onHide = () => {
        isVisible.value = false;
        emit('update:visible', false);
    }

    const onChangeName = async () => {
        try {
            const response = await util$.pinia$.app.busyFor('', async () => {
                return await util$.http$.post(url$.auth.concat('change-name'), {
                    account: userInfo.value.account,
                    name: name.value,
                    secret: oSecret.value
                }).catch((error) => {
                    const { code } = util$.http$.extractError(error);
                    if (code === 'INVALID_SECRET') {
                        util$.messenger$.error(t('accMgmt.wrongSecret'));
                    }
                });
            });
            if (response.result) {
                userInfo.value.name = name.value;
                util$.toast$?.info('', t('accMgmt.changed'), 'c', 3000);
            }
        }
        finally {
            oSecret.value = '';
        }
    }

    const onChangeSecret = async () => {
        try {
            const response = await util$.pinia$.app.busyFor('', async () => {
                return await util$.http$.post(url$.auth.concat('change-secret'), {
                    account: userInfo.value.account,
                    secret: oSecret.value,
                    nSecret: nSecret.value
                }).catch((error) => {
                    const { code } = util$.http$.extractError(error);
                    if (code === 'INVALID_SECRET') {
                        util$.messenger$.error(t('accMgmt.wrongSecret'));
                    }
                });
            });
            if (response.result) {
                userInfo.value.name = name.value;
                util$.toast$?.info('', t('accMgmt.changed'), 'c', 3000);
            }
        }
        finally {
            oSecret.value = '';
            nSecret.value = '';
        }
    }

    //***************元件監看**************
    watchEffect(() => {
        isVisible.value = props.visible;
    });

    //***************元件鉤子**************

</script>